import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { IProfileSLADefinition } from './bp-profiles-sla-data.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { util } from '../../../../shared/util';
import { ProfileAttributeStatusIcon } from '../../profile-attributes/bp-profiles-attributes.service';

@Component({
  selector: 'bp-profiles-sla-definitions',
  template: `
    <form #slaDefinitionsForm="ngForm">
      <div class="profile-attribute" *ngFor="let slaDefinition of slaDefinitions; let idx = index; trackById">
        <div class="row profile-attribute-value-container" [class.read-mode]="!editingMode" [class.self-attribute-content]="!slaDefinition.slaValue?.comments">
          <div [ngClass]="editingMode? 'col-sm-12' : 'col-sm-10'">
            <label class="profile-attribute-description">
              <i class="fa profile-attribute-status-icon" [ngClass]="getStatusIcon(slaDefinition)"></i>
              <span class="description">
                <span>{{slaDefinition.textFrom}} <i class="fa fa-long-arrow-right margin-left-xs margin-right-xs"></i> {{slaDefinition.textTo}}</span>
                <info-link class="profile-attribute-info" [(linkVariable)]="slaDefinition.showInfo" *ngIf="slaDefinition.description"></info-link>
              </span>
            </label>

            <div class="info-row row" *ngIf="slaDefinition.showInfo">
              <div class="info col-sm-12" [innerHTML]="slaDefinition.description"></div>
            </div>
          </div>

          <div class="col-sm-2" *ngIf="!editingMode">
            <p class="profile-attribute-value">{{ slaDefinition.slaValue?.days | format: 'formatDays' }}</p>
          </div>

          <div class="col-sm-10" *ngIf="!editingMode && slaDefinition.slaValue?.comments">
            <p class="profile-attribute-comment-value" [innerHTML]="slaDefinition.slaValue.comments"></p>
          </div>
        </div>
        
        <div class="row profile-attribute-control" *ngIf="editingMode">
          <div class="attribute-control col-md-3 col-sm-6 col-4">
            <div class="input-group input-group-sm">
              <input type="number" [name]="getControlName('input-value', idx)" class="form-control" [(ngModel)]="slaDefinition.slaValue.days" [placeholder]="'BPPROFILES.SLA.NUMBER_OF' | translate" min="0">
              <span class="input-group-text" translate>GA.GENERAL.DAYS</span>
            </div>
          </div>
          
          <div class="attribute-control col-md-9 col-sm-6 col-8">
            <button class="btn btn-default use-default" (click)="slaDefinition.slaValue.days = slaDefinition.defaultDays">
              <i class="fa fa-chevron-left"></i>
              <span class="margin-left-xs" [translateParams]="{ days: slaDefinition.defaultDays }" translate>BPPROFILES.SLA.USE_DEFAULT_DAYS</span>
            </button>
          </div>
          
          <div class="attribute-control col-sm-12">
            <input type="text" [name]="getControlName('input-comments', idx)" class="form-control input-comment-control" [placeholder]="'GA.GENERAL.COMMENTS' | translate" [(ngModel)]="slaDefinition.slaValue.comments">
          </div>
        </div>
      </div>
    </form>
  `,
  styleUrls: ['../../profile-attributes/bp-profiles-attributes.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BPProfilesSLADefinitionsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('slaDefinitionsForm') public slaDefinitionsForm:NgForm;
  @Input() public editingMode:boolean;
  @Input() public slaDefinitions:IProfileSLADefinition[];

  @Output() public slaDefinitionsChange:EventEmitter<IProfileSLADefinition[]> = new EventEmitter<IProfileSLADefinition[]>();

  private onValueChangesSubscription:Subscription;

  public ngAfterViewInit():void {
    // register listener
    this.listen();
  }

  private listen():void {
    this.onValueChangesSubscription = this.slaDefinitionsForm.form.valueChanges.subscribe(() => {
      // listen on form model changes and then emit updated value to 'model' input bindings
      this.slaDefinitionsChange.emit(this.slaDefinitions);
    });
  }

  public getStatusIcon(slaDefinition:IProfileSLADefinition):string {
    if (util.isNullOrUndefinedOrEmpty(slaDefinition.slaValue.days)) {
      return ProfileAttributeStatusIcon.WARNING;
    } else {
      return ProfileAttributeStatusIcon.OK;
    }
  }

  public getControlName(fieldName:string, index:number):string {
    return `${fieldName}-${index}`;
  }

  public ngOnDestroy():void {
    this.onValueChangesSubscription?.unsubscribe();
  }
}